import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanClosingNOC.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const LoanClosingNOC = () => {
  const nocRef = useRef();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);

  const loan = state||null;
  const branchId = Number(localStorage.getItem("userId")) || 0;

 useEffect(() => {
  dispatch(fetchUserProfile());
}, [dispatch]);

useEffect(() => {
  if (!profile?.superAdminId) return;

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
      );
      const data = await res.json();

      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchCompany();
}, [profile?.superAdminId]);

useEffect(() => {
  if (!loan?.userId || !profile?.superAdminId) return;

  const fetchCustomer = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/customers-get-userId?userId=${loan.customerId}&branchId=${branchId}`
      );
      const result = await res.json();
      console.log("cusotmer",result)
      setCustomerDetails(result?.data || null);
    } catch (err) {
      console.error(err);
    }
  };

  fetchCustomer();
}, [loan?.customerId, profile?.superAdminId,branchId]);


  /* ================== SAFETY ================== */
  if (!loan) {
    return (
      <div className="noc-error">
        <p>No loan data found</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }


  /* ================== PDF ================== */
  const downloadPDF = async () => {
    const canvas = await html2canvas(nocRef.current, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "pt", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Loan_Closure_NOC_${loan.userName}.pdf`);
  };

  /* ================== PRINT ================== */
const printNOC = () => {
  if (!nocRef.current) return;

  const printWindow = window.open("", "_blank", "width=900,height=650");

  printWindow.document.write(`
    <html>
      <head>
        <title>Loan Closing NOC</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }

          .noc-container {
            width: 100%;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
          }

          table td {
            border: 1px solid #000;
            padding: 8px;
            font-size: 13px;
          }

          h1, h2 {
            text-align: center;
          }

          img {
            max-height: 70px;
          }
        </style>
      </head>
      <body>
        ${nocRef.current.innerHTML}
      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


  return (
    <div className="noc-wrapper">
      {/* ACTIONS */}
      <div className="noc-actions no-print">
        <button onClick={downloadPDF}>⬇ Download PDF</button>
        <button onClick={printNOC}>🖨 Print</button>
      </div>

      {/* NOC CONTENT */}
      <div className="noc-container" ref={nocRef}>
        {/* HEADER */}
        <div className="noc-header">
          <div className="noc-logo">
            {company?.logoUrl && (
              <img src={company.logoUrl} alt="Company Logo" />
            )}
          </div>

          <div className="noc-company-details">
            <h1>{company?.name || "Company Name"}</h1>
            {/* <p>{company?.cin || "Company Cin"}</p> */}
            <p>{company?.address || "Company Address"}</p>
            <p>
              Email: {company?.email || "-"} | Phone: {company?.contact || "-"}
            </p>
          </div>
        </div>

        <hr />

        {/* BODY */}
        <div className="noc-body">
          <h2>NO OBJECTION CERTIFICATE (NOC)</h2>

          <p className="noc-date">
            Date: <strong>{new Date().toLocaleDateString("en-GB")}</strong>
          </p>

          <p className="noc-paragraph">
            This is to certify that <strong>{loan.userName}</strong>, residing
            at <strong>{customerDetails?.address || "—"}</strong>, has availed a
            loan from <strong>{company?.name}</strong>.
          </p>

          <table className="noc-table">
            <tbody>
              <tr>
                <td>Customer Name</td>
                <td>{loan.userName}</td>
              </tr>
              <tr>
                <td>Customer ID</td>
                <td>{loan.customerId}</td>
              </tr>
              <tr>
                <td>Loan Account Number</td>
                <td>{loan.loanAccountNumber}</td>
              </tr>
              <tr>
                <td>Loan Type</td>
                <td>{loan.loanType}</td>
              </tr>
              <tr>
                <td>Loan Amount</td>
                <td>₹ {loan.loanAmount}</td>
              </tr>
              {/* <tr>
                <td>Loan Start Date</td>
                <td>
                  {new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")}
                </td>
              </tr> */}
              <tr>
                <td>Loan Closing Date</td>
                <td>
                  {loan?.closedAt?new Date(loan.closedAt).toLocaleDateString("en-GB"):"N/A"||loan?.forceClosedAt? new Date(loan.forceClosedAt).toLocaleDateString("en-GB"):"N/A"}
                </td>
              </tr>
            </tbody>
          </table>

          <p className="noc-paragraph">
            We hereby confirm that the above-mentioned loan account has been
            <strong> fully repaid</strong> and there are
            <strong> no outstanding dues</strong> as on date.
          </p>

          <p className="noc-paragraph">
            Accordingly, we have <strong>no objection</strong> in closing the
            said loan account and releasing any charge or lien created against
            it.
          </p>

          <div className="noc-footer">
            <p>
              For <strong>{company?.name}</strong>
            </p>
            <br />
            <p>Authorized Signatory</p>
          </div>
        </div>

        <div className="noc-note">
          <p>This is a system generated document.signature with stamp is required.</p>
        </div>
      </div>
    </div>
  );
};

export default LoanClosingNOC;



